<template>
  <div class="menu">
    <el-row type="flex">
      <el-col :span="6">
        <el-card shadow="hover" class="box-card">
          <div slot="header" class="clearfix">
            <span>组织架构</span>
          </div>
          <el-tree
            class="company-tree"
            :data="companyList"
            :expand-on-click-node="false"
            default-expand-all
            highlight-current
            node-key="id"
            @node-click="handleNodeClick"
            :filter-node-method="filterNode"
            ref="tree"
            v-bind:style="{ height: heightTree, 'overflow-y': 'auto' }"
          >
          </el-tree>
        </el-card>
      </el-col>
      <el-col :span="18">
        <el-card>
          <div slot="header" class="title">
            <span>关联业务与银行账户</span>
          </div>
          <SiruiSearch
            :colSpan="12"
            :isQueryPanel="false"
            ref="siruiSearch"
            :query="query"
            :columns="searchColumns"
          />
        </el-card>
        <el-card class="button-container">
          <el-button type="primary" icon="el-icon-plus" @click="handleAddNewRow">
            添加新行
          </el-button>
          <el-button type="primary" icon="el-icon-check" @click="handleSaveConfig">
            保存配置
          </el-button>
          <el-button type="primary" icon="el-icon-refresh" @click="handleReset"> 重置</el-button>
        </el-card>
        <sirui-table
          ref="siruiTable"
          :loading="loading"
          :data="tableData"
          :columns="columnListDefault"
          @handleSizeChange="handleSizeChange"
          @handleCurrentChange="handleCurrentChange"
          @handleSelectionChange="handleSelectionChange"
        >
          <vxe-table-column type="seq" title="序号" width="50" fixed="left" />
          <vxe-table-column
            v-for="(item, index) in columnListDefault"
            :key="index"
            :fixed="item.fixed"
            :visible="item.visible"
            :width="item.width || 120"
            :sortable="item.sortable"
            :formatter="item.formatter"
            :field="item.field"
            :type="item.type"
            :params="item.params"
            :title="item.title ? $t(item.title) : null"
          >
            <template #default="{ row }">
              <template v-if="item.field === 'bankCardNo'">
                <el-input v-model="row.bankCardNo" v-if="row.isEditing" />
                <span v-else>{{ row.bankCardNo }}</span>
              </template>
              <template v-else-if="item.field === 'remark'">
                <el-input v-model="row.remark" v-if="row.isEditing" />
                <span v-else>{{ row.remark }}</span>
              </template>
              <template v-else>
                {{ row[item.field] }}
              </template>
            </template>
          </vxe-table-column>
          <vxe-table-column title="操作" width="150">
            <template #default="{ row, rowIndex }">
              <el-button type="text" @click="handleDelete(row)" v-if="row.id !== 'new'"
                >删除
              </el-button>
              <el-button type="text" @click="handleSave(row, rowIndex)" v-if="row.isEditing"
                >保存
              </el-button>
              <el-button type="text" @click="handleEdit(row, rowIndex)" v-if="!row.isEditing"
                >编辑
              </el-button>
            </template>
          </vxe-table-column>
        </sirui-table>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import tableMixins from '@/common/mixins/table.js';
  import API from '@/api/financeCenter/bizBankCfg';
  import { filterEmpty } from '@/common/js/util';

  export default {
    name: 'bizBankCfgList',
    mixins: [tableMixins],
    data() {
      return {
        loading: false,
        //公司列表
        companyList: [],
        defaultProps: {
          children: 'children',
          label: 'label',
        },
        // 查询条件
        query: {
          companyName: '',
          // 关联业务码
          businessCode: '',
          // 关联银行账户
          bankCardNo: '',
        },
        // 所有数据
        allTableData: [],
        // 右侧列表数据
        tableData: [],
      };
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
        tokenInfo() {
          return {
            access_token: this.userInfo.access_token,
            companyCode: this.userInfo.companyCode,
            companyName: this.userInfo.companyName,
            departmentCode: this.userInfo.departmentCode,
            departmentName: this.userInfo.departmentName,
            tenantCode: this.userInfo.tenantCode,
          };
        },
      }),
      //搜索字段
      searchColumns() {
        return [
          //当前组织
          {
            prop: 'companyName',
            name: '当前组织',
            type: 'input',
            width: 'auto',
            disabled: true,
          },
          // 关联业务码
          {
            prop: 'businessCode',
            name: '关联业务码',
            type: 'input',
            placeholder: '请输入关联业务码',
            width: 'auto',
          },
          // 关联银行账户
          {
            prop: 'bankCardNo',
            name: '关联银行账户',
            type: 'input',
            placeholder: '请输入银行卡号',
            width: 'auto',
          },
        ];
      },
      //表格显示字段
      columnListDefault() {
        return [
          //银行卡号
          { field: 'bankCardNo', title: '银行卡号', visible: true, width: 'auto' },
          {
            field: 'remark',
            title: '备注',
            visible: true,
            width: 'auto',
          },
        ];
      },
      heightTree() {
        return window.innerHeight - 195 + 'px';
      },
    },
    /**
     * 页面必要代码Start
     */
    mounted() {
      this.$nextTick(() => {
        this.getCompany();
      });
    },
    watch: {
      'query.bankCardNo': function (newValue) {
        this.filterTableData(newValue);
      },
    },
    methods: {
      // 关联银行账户查询时调用方法
      filterTableData(keyword) {
        if (!keyword) {
          console.log(keyword, '进入');
          // 重置表格数据为全部数据
          this.tableData = this.allTableData;
          // 更新当前页数据
          const { pageNum, pageSize } = this.$refs.siruiTable.page;
          console.log(pageNum, pageSize);
          // 重置分页信息
          this.$refs.siruiTable.page.total = this.allTableData.length;
          this.$refs.siruiTable.page.pageNum = pageNum;
          this.$refs.siruiTable.page.pageSize = pageSize;
          const start = (pageNum - 1) * pageSize;
          const end = start + pageSize;
          this.tableData = this.allTableData.slice(start, end);
          return;
        }
        console.log('没劲');
        // 过滤数据
        this.tableData = this.allTableData.filter((row) => row.bankCardNo.includes(keyword));

        // 更新分页信息
        this.$refs.siruiTable.page.total = this.tableData.length;

        // 获取当前页码和每页大小
        const { pageNum, pageSize } = this.$refs.siruiTable.page;
        console.log(pageNum, pageSize);

        // 计算当前页的起始和结束索引
        const start = (pageNum - 1) * pageSize;
        const end = start + pageSize;

        // 更新 tableData 为当前页的数据
        this.tableData = this.tableData.slice(start, end);

        // 如果当前页码大于总页数，则跳转到最后一页
        if (pageNum > Math.ceil(this.tableData.length / pageSize)) {
          this.$refs.siruiTable.page.pageNum = Math.ceil(this.tableData.length / pageSize);
          this.filterTableData(keyword); // 重新调用以更新数据
        }
      },
      // 获取公司
      async getCompany() {
        console.log(this.userInfo, 'userInfo');
        let newItem = this.userInfo.allDepartmentList || [];
        // 去重逻辑，根据 personCompanyCode 去重
        let uniqueItems = Array.from(new Set(newItem.map((item) => item.personCompanyCode))).map(
          (personCompanyCode) =>
            newItem.find((item) => item.personCompanyCode === personCompanyCode)
        );
        // 组装数据
        this.companyList = uniqueItems.map((item) => {
          return {
            label: item.personCompanyName,
            value: item.personCompanyCode,
            children: {
              value: item.personDepartmentCode,
              label: item.personDepartmentName,
            },
          };
        });
        this.getSelectedNode(this.companyList, this.companyList);
        console.log(this.companyList, '公司');
      },
      //删掉没有子节点的children
      getSelectedNode(nodeData) {
        nodeData.forEach((item) => {
          if ('children' in item && item.children.length === 0) {
            delete item.children;
          } else if ('children' in item && item.children.length) {
            this.getSelectedNode(item.children, item);
          }
        });
      },
      filterNode(value, data) {
        if (!value) return true;
        return data.label.indexOf(value) !== -1;
      },
      //选择一条组织架构
      handleNodeClick(data) {
        console.log(data, '选择一条组织架构');
        this.query.businessCode = '';
        this.query.companyName = data.label;
        this.findDataByCompanyName(this.query.companyName);
      },
      // 关联业务与银行账户根据公司名称获取
      findDataByCompanyName(title) {
        let params = {
          companyName: title,
        };
        this.getData(params);
      },
      // 查询接口,获取数据
      getData(params) {
        this.allTableData = [];
        this.tableData = [];
        console.log(params, '<==========查看参数');
        // 获取分页参数
        const { pageNum, pageSize } = this.$refs.siruiTable.page;
        const query = { ...params };
        this.loading = true;
        this.$axios.get(API.GET_CONFIG_BY_COMPANY_NAME, filterEmpty(query)).then((res) => {
          console.log(res, '查询接口返回数据');
          if (0 === res.data.code) {
            if (!res.data.data) {
              this.loading = false;
              this.dataId = '';
              this.$message.warning('该组织下暂无数据,请进行添加');
              return;
            }
            this.tableData = res.data.data.bankCardList || [];
            this.query.companyName = res.data.data.companyName || '';
            this.query.businessCode = res.data.data.businessCode || '';
            this.dataId = res.data.data.id || '';
            const total = res.data.data.bankCardList.length;
            const start = (pageNum - 1) * pageSize;
            const end = start + pageSize;
            this.tableData = res.data.data.bankCardList.slice(start, end);
            // 合并分页数据到 allTableData
            this.allTableData = res.data.data.bankCardList.slice(0, total); // 确保 allTableData 包含所有数据
            this.$refs.siruiTable.setPageTotal(res.data.data.bankCardList.length);
            this.loading = false;
          } else {
            this.loading = false;
            this.$message.warning('该组织下暂无数据,请进行添加');
          }
        });
      },
      handleSizeChange(size) {
        console.log('handleSizeChange~');
        this.$refs.siruiTable.page.pageSize = size;
        this.getData(this.query);
      },
      handleCurrentChange(page) {
        console.log('handleCurrentChange~');
        this.$refs.siruiTable.page.pageNum = page;
        this.getData(this.query);
      },
      // 删除行内
      handleDelete(row) {
        console.log(row, '删除行内');
        const index = this.tableData.findIndex((item) => item.id === row.id);
        if (index > -1) {
          this.tableData.splice(index, 1);
        }
        // 同步删除 allTableData 中的对应行
        const allIndex = this.allTableData.findIndex((item) => item.id === row.id);
        if (allIndex > -1) {
          this.allTableData.splice(allIndex, 1);
        }
        console.log(this.tableData, '删除后的 tableData');
        console.log(this.allTableData, '删除后的 allTableData');
      },
      // 保存行内
      handleSave(row, rowIndex) {
        console.log(this.tableData, '保存行内前 tableData');
        console.log(this.allTableData, '保存行内前 allTableData');
        // 获取当前行的数据
        const currentRow = this.tableData[rowIndex];
        // 判断一下是否为空
        if (!row.bankCardNo || row.bankCardNo === '') {
          this.$message.warning('请输入银行卡号');
          return;
        }
        // 更新当前行的数据
        currentRow.bankCardNo = row.bankCardNo;
        currentRow.remark = row.remark;
        // 设置为非编辑状态
        currentRow.isEditing = false;
        // 如果需要，可以在这里添加保存到服务器的逻辑
        console.log('保存行内数据:', currentRow, '<==rowIndex=======>', rowIndex);
        console.log(this.tableData, '保存行内后 tableData');
        console.log(this.allTableData, '保存行内后 allTableData');
        this.$forceUpdate();
        // 添加总行数
        this.$refs.siruiTable.setPageTotal(this.allTableData.length);
      },
      // 重置
      handleReset() {
        // 提示
        this.$confirm(
          '重置配置后，已修改的内容不会保存，并加载未保存前的配置，是否继续？',
          '重置提示',
          {
            confirmButtonText: '确定',
            cancelButtonText: '关闭',
            type: 'warning',
          }
        )
          .then(() => {
            // 重置配置
            this.getData(this.query.companyName);
          })
          .catch(() => {
            // 取消重置
          });
      },
      // 保存配置
      handleSaveConfig() {
        if (this.hasUnsavedRows()) {
          this.$message.warning('存在未保存的行，请先保存再进行保存配置操作');
          return;
        }
        // 判断用户是否选择了组织
        if (!this.query.companyName) {
          this.$message.warning('请先选择组织');
          return;
        }
        // 判断用户是否输入关联业务码
        if (!this.query.businessCode) {
          this.$message.warning('请输入关联业务码');
          return;
        }
        // 校验关联业务码
        const regex = /^(?=.*[a-zA-Z])(?=.*\d)[a-zA-Z\d]{8,20}$/;
        if (!regex.test(this.query.businessCode)) {
          this.$message.warning('关联业务码必须包含字母和数字，且长度在8-20位之间');
          return;
        }
        console.log('保存配置', this.allTableData);
        // 封装参数
        let params = {
          bankCardList: this.allTableData,
          companyName: this.query.companyName,
          businessCode: this.query.businessCode,
          isDeleted: 0,
        };
        // 验证是否有id
        if (this.dataId) {
          params.id = this.dataId;
        }
        this.loading = true;
        this.$axios.post(API.SAVE_CONFIG, params).then((res) => {
          console.log(res, '保存返回数据');
          if (res.data.msg === '保存成功') {
            // 保存配置提示,提示保存配置成功,需要点击关闭按钮
            this.$confirm('保存配置成功！', '保存配置提示', {
              confirmButtonText: '确定',
              type: 'success', // 将类型改为 success 更符合成功提示的语义
              showCancelButton: false, // 隐藏取消按钮
            })
              .then(() => {
                // 关闭弹窗
                this.$emit('close');
              })
              .catch(() => {
                // 取消关闭，这里不需要做任何操作，因为取消按钮被隐藏了
              });
            this.loading = false;
          } else {
            this.loading = false;
            return this.$message.error('保存失败');
          }
        });
      },
      // 新增行内新行
      handleAddNewRow() {
        const { pageNum, pageSize } = this.$refs.siruiTable.page;

        // 计算当前页的起始和结束索引
        const start = (pageNum - 1) * pageSize;
        const end = start + pageSize;

        // 检查当前页是否已满
        if (this.tableData.length >= pageSize) {
          const { pageNum, pageSize } = this.$refs.siruiTable.page;
          // 判断是否还有下一页,没有下一页,执行以下操作
          if (pageNum === Math.ceil(this.allTableData.length / pageSize)) {
            // 增加页码
            this.$refs.siruiTable.setPageNum(pageNum + 1);
            // 更新总页数
            this.$refs.siruiTable.setPageTotal(Math.ceil(this.allTableData.length / pageSize) + 1);
            // 更新当前页数据
            this.tableData = this.allTableData.slice(end, end + pageSize);
          } else {
            this.$message.warning('当前页已满，请在下一页进行添加');
            return;
          }
        }

        // 新行数据
        const newRow = {
          id: Date.now(), // 使用时间戳生成唯一的ID
          bankCardNo: '', // 关联银行账户
          remark: '',
          isNew: true, // 添加标识符
          isEditing: true, // 直接设置为编辑状态
          isDeleted: 0,
        };
        this.tableData.push(newRow);
        this.allTableData.push(newRow); // 同步添加到 allTableData
      },
      // 检查是否有未保存的行
      hasUnsavedRows() {
        return this.allTableData.some((row) => row.isEditing);
      },
      // 编辑行
      handleEdit(row, rowIndex) {
        // 获取当前行的数据
        const currentRow = this.tableData[rowIndex];
        // 设置当前行为编辑状态
        currentRow.isEditing = true;
        this.$forceUpdate();
      },
    },
  };
</script>
<style scoped>
  .button-container {
    margin-bottom: -35px;
  }
</style>
